import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Avatar, Menu, MenuItem, Tooltip } from "@mui/material";
import { logout } from "../../api/fetch";
import { useAuth } from "../../services/AuthContext";
import Swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const drawerWidth = 250;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(3)",
      opacity: 0,
    },
  },
}));

const settings = ["Logout"];

export default function AppBarHeader({
  open,
  handleOpenUserMenu,
  toggleDrawer,
  anchorElUser,
  handleCloseUserMenu,
}) {
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const authToken = localStorage.getItem("adminToken");

    try {
      const res = await logout(authToken);

      if (res?.status) {
        localStorage.removeItem("adminToken");
        setUser(null);
        navigate("/");
        Swal({
          title: res?.msg,
          // text: res?.msg,
          timer: 1000,
        });
      }
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  return (
    <AppBar
      position="fixed"
      open={open}
      style={{
        background: "#000",
      }}
    >
      <Toolbar
        sx={{
          pr: "24px", // keep right padding when drawer closed
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer}
          sx={{
            marginRight: "36px",
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
          style={{ fontFamily: "Poppins" }}
        >
          Dashboard
        </Typography>
        <IconButton color="inherit">
          <Badge badgeContent={0} color="default">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Admin" arrow>
            <StyledBadge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              variant="dot"
            >
              <Avatar
                onClick={handleOpenUserMenu}
                alt="Remy Sharp"
                src={"https://randomuser.me/api/portraits/men/1.jpg"}
                style={{ cursor: "pointer" }}
              />
            </StyledBadge>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={handleLogout}>
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
